// extracted by extract-css-chunks-webpack-plugin
module.exports = {"challengeCard":"TO-jv","titleRow":"uwtTX","iconWrapper":"_30X8S","title":"vVTmh","detailsLink":"_6ATwc","earnValue":"v549N"};